export default __webpack_public_path__ + "static/DIN-Medium-Alternate-0cca84f431b85849e4f1d4cbbba41747.woff";